import { render, staticRenderFns } from "./EventInfoModalSubHeader.vue?vue&type=template&id=6a74f364&scoped=true&"
import script from "./EventInfoModalSubHeader.vue?vue&type=script&lang=js&"
export * from "./EventInfoModalSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoModalSubHeader.vue?vue&type=style&index=0&id=6a74f364&lang=scss&scoped=true&"
import style1 from "./EventInfoModalSubHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74f364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDivider,VFlex,VToolbar})
